var map = {
	"./0/Kambi/Header.mobile.layout": [
		14704,
		9629,
		2090
	],
	"./0/Kambi/Header.pc.layout": [
		99185,
		9629,
		8425
	],
	"./0/Kambi/HomeSection.layout": [
		48995,
		9629,
		7738
	],
	"./0/Kambi/SecondaryMenu.layout": [
		8017,
		9629,
		6277
	],
	"./0/Kambi/UsefulLinks.layout": [
		71360,
		9629,
		1539
	],
	"./0/Poker/Header.mobile.layout": [
		50289,
		9629,
		3673
	],
	"./0/Poker/Header.pc.layout": [
		36984,
		9629,
		3586
	],
	"./0/Poker/HomeSection.layout": [
		63170,
		9629,
		9345
	],
	"./0/Poker/LoyaltySection.layout": [
		73189,
		9629,
		4410
	],
	"./0/Poker/SecondaryMenu.layout": [
		4131,
		9629,
		1886
	],
	"./0/Poker/UsefulLinks.layout": [
		33017,
		9629,
		6804
	],
	"./0/Spectate/Header.mobile.layout": [
		74385,
		9629,
		273
	],
	"./0/Spectate/Header.pc.layout": [
		90744,
		9629,
		8474
	],
	"./0/Spectate/HomeSection.layout": [
		86434,
		9629,
		4521
	],
	"./0/Spectate/SecondaryMenu.layout": [
		33790,
		9629,
		7894
	],
	"./0/Spectate/UsefulLinks.layout": [
		60281,
		9629,
		3212
	],
	"./1/Kambi/Header.mobile.layout": [
		80853,
		9629,
		7906
	],
	"./1/Kambi/Header.pc.layout": [
		32940,
		9629,
		5310
	],
	"./1/Kambi/HomeSection.layout": [
		94398,
		9629,
		3237
	],
	"./1/Kambi/SecondaryMenu.layout": [
		21623,
		6266
	],
	"./1/Kambi/UsefulLinks.layout": [
		35397,
		9629,
		8456
	],
	"./1/Poker/Header.mobile.layout": [
		63688,
		9629,
		7822
	],
	"./1/Poker/Header.pc.layout": [
		13289,
		9629,
		4989
	],
	"./1/Poker/HomeSection.layout": [
		51835,
		9629,
		6774
	],
	"./1/Poker/LoyaltySection.layout": [
		78502,
		9629,
		4895
	],
	"./1/Poker/SecondaryMenu.layout": [
		83330,
		9629,
		5145
	],
	"./1/Poker/UsefulLinks.layout": [
		81512,
		9629,
		7935
	],
	"./1/Spectate/Header.mobile.layout": [
		56254,
		9629,
		6118
	],
	"./1/Spectate/Header.pc.layout": [
		14763,
		9629,
		4661
	],
	"./1/Spectate/HomeSection.layout": [
		75701,
		9629,
		9086
	],
	"./1/Spectate/SecondaryMenu.layout": [
		97680,
		9629,
		2593
	],
	"./1/Spectate/UsefulLinks.layout": [
		5650,
		9629,
		327
	],
	"./31/Kambi/Header.mobile.layout": [
		27720,
		9629,
		8010
	],
	"./31/Kambi/Header.pc.layout": [
		13975,
		9629,
		535,
		4329
	],
	"./31/Kambi/HomeSection.layout": [
		90011,
		9629,
		2410
	],
	"./31/Kambi/SecondaryMenu.layout": [
		38185,
		9629,
		837
	],
	"./31/Kambi/UsefulLinks.layout": [
		19688,
		9629,
		7059
	],
	"./31/Poker/Header.mobile.layout": [
		86201,
		9629,
		895
	],
	"./31/Poker/Header.pc.layout": [
		61696,
		9629,
		2636
	],
	"./31/Poker/HomeSection.layout": [
		3786,
		9629,
		5815
	],
	"./31/Poker/LoyaltySection.layout": [
		79997,
		9629,
		612
	],
	"./31/Poker/SecondaryMenu.layout": [
		38342,
		9629,
		3272
	],
	"./31/Poker/UsefulLinks.layout": [
		99409,
		9629,
		2946
	],
	"./31/Spectate/Header.mobile.layout": [
		15881,
		9629,
		2071
	],
	"./31/Spectate/Header.pc.layout": [
		72176,
		9629,
		535,
		1716
	],
	"./31/Spectate/HomeSection.layout": [
		88570,
		9629,
		4863
	],
	"./31/Spectate/SecondaryMenu.layout": [
		78059,
		9629,
		5120
	],
	"./31/Spectate/UsefulLinks.layout": [
		42049,
		9629,
		6762
	],
	"./58/Spectate/Header.mobile.layout": [
		17948,
		9629,
		6882
	],
	"./58/Spectate/Header.pc.layout": [
		24653,
		9629,
		8529
	],
	"./58/Spectate/HistorySection.layout": [
		89832,
		9629,
		1425
	],
	"./58/Spectate/HomeSection.layout": [
		47911,
		9629,
		9426
	],
	"./58/Spectate/SecondaryMenu.layout": [
		39885,
		9629,
		5021
	],
	"./58/Spectate/UsefulLinks.layout": [
		42084,
		9629,
		267
	],
	"./75/Kambi/Header.mobile.layout": [
		33440,
		9629,
		5858
	],
	"./75/Kambi/Header.pc.layout": [
		97121,
		9629,
		7569
	],
	"./75/Kambi/HomeSection.layout": [
		62195,
		9629,
		7010
	],
	"./75/Kambi/SecondaryMenu.layout": [
		66881,
		9629,
		7645
	],
	"./75/Kambi/UsefulLinks.layout": [
		99952,
		9629,
		7851
	],
	"./75/Spectate/Header.mobile.layout": [
		23713,
		9629,
		2487
	],
	"./75/Spectate/Header.pc.layout": [
		95272,
		9629,
		6884
	],
	"./75/Spectate/HomeSection.layout": [
		62258,
		9629,
		3231
	],
	"./75/Spectate/SecondaryMenu.layout": [
		97550,
		9629,
		4208
	],
	"./75/Spectate/UsefulLinks.layout": [
		1545,
		9629,
		5354
	],
	"./76/Kambi/Header.mobile.layout": [
		78187,
		9629,
		7047
	],
	"./76/Kambi/Header.pc.layout": [
		87030,
		9629,
		5284
	],
	"./76/Kambi/HomeSection.layout": [
		32416,
		9629,
		3791
	],
	"./76/Kambi/SecondaryMenu.layout": [
		81061,
		9629,
		6288
	],
	"./76/Kambi/UsefulLinks.layout": [
		80567,
		9629,
		1306
	],
	"./76/Spectate/Header.mobile.layout": [
		21024,
		9629,
		9026
	],
	"./76/Spectate/Header.pc.layout": [
		6305,
		9629,
		4273
	],
	"./76/Spectate/HomeSection.layout": [
		94835,
		9629,
		3842
	],
	"./76/Spectate/SecondaryMenu.layout": [
		5089,
		9629,
		7517
	],
	"./76/Spectate/UsefulLinks.layout": [
		32592,
		9629,
		9867
	],
	"./8/Poker/Header.mobile.layout": [
		1209,
		9629,
		705
	],
	"./8/Poker/Header.pc.layout": [
		55808,
		9629,
		3498
	],
	"./8/Poker/HomeSection.layout": [
		13834,
		9629,
		9657
	],
	"./8/Poker/LoyaltySection.layout": [
		70333,
		9629,
		6530
	],
	"./8/Poker/SecondaryMenu.layout": [
		23323,
		9629,
		2566
	],
	"./8/Poker/UsefulLinks.layout": [
		70225,
		9629,
		9228
	],
	"./8/Spectate/Header.mobile.layout": [
		77641,
		9629,
		7609
	],
	"./8/Spectate/Header.pc.layout": [
		38142,
		9629,
		3885,
		2658
	],
	"./8/Spectate/HistorySection.layout": [
		18615,
		9629,
		2588
	],
	"./8/Spectate/HomeSection.layout": [
		83866,
		9629,
		8465
	],
	"./8/Spectate/RegulationLogosSection.layout": [
		50019,
		6080
	],
	"./8/Spectate/SecondaryMenu.layout": [
		65881,
		9629,
		8792,
		1198
	],
	"./8/Spectate/UsefulLinks.layout": [
		81377,
		9629,
		6532
	],
	"./81/Kambi/Header.mobile.layout": [
		77741,
		9629,
		8165
	],
	"./81/Kambi/Header.pc.layout": [
		32772,
		9629,
		6256,
		4510
	],
	"./81/Kambi/HomeSection.layout": [
		70646,
		9629,
		7477
	],
	"./81/Kambi/SecondaryMenu.layout": [
		68634,
		9629,
		5866
	],
	"./81/Kambi/UsefulLinks.layout": [
		20941,
		9629,
		7016
	],
	"./81/Spectate/Header.mobile.layout": [
		97334,
		9629,
		632
	],
	"./81/Spectate/Header.pc.layout": [
		18787,
		9629,
		6256,
		115
	],
	"./81/Spectate/HomeSection.layout": [
		61325,
		9629,
		3152
	],
	"./81/Spectate/SecondaryMenu.layout": [
		85447,
		9629,
		6951
	],
	"./81/Spectate/UsefulLinks.layout": [
		45146,
		9629,
		9185
	],
	"./84/Kambi/Header.mobile.layout": [
		34500,
		9629,
		2926
	],
	"./84/Kambi/Header.pc.layout": [
		43989,
		7597
	],
	"./84/Kambi/HomeSection.layout": [
		49999,
		9629,
		7062
	],
	"./84/Kambi/SecondaryMenu.layout": [
		45614,
		9629,
		249
	],
	"./84/Kambi/UsefulLinks.layout": [
		93692,
		9629,
		8223
	],
	"./84/Spectate/Header.mobile.layout": [
		89301,
		9629,
		5455
	],
	"./84/Spectate/Header.pc.layout": [
		77100,
		9629,
		5964
	],
	"./84/Spectate/HomeSection.layout": [
		4145,
		9629,
		2087
	],
	"./84/Spectate/SecondaryMenu.layout": [
		16140,
		9629,
		4040
	],
	"./84/Spectate/UsefulLinks.layout": [
		59397,
		9629,
		4466
	],
	"./86/Spectate/Header.mobile.layout": [
		57823,
		9629,
		3365
	],
	"./86/Spectate/Header.pc.layout": [
		53074,
		9629,
		296,
		2414
	],
	"./86/Spectate/HomeSection.layout": [
		72540,
		9629,
		7525
	],
	"./86/Spectate/SILinks.mobile.layout": [
		82241,
		257
	],
	"./86/Spectate/SILinks.pc.layout": [
		25160,
		7338
	],
	"./86/Spectate/SecondaryMenu.layout": [
		41529,
		9629,
		1066
	],
	"./86/Spectate/UsefulLinks.layout": [
		97683,
		9629,
		7064
	],
	"./87/Spectate/Header.mobile.layout": [
		12500,
		9629,
		989
	],
	"./87/Spectate/Header.pc.layout": [
		84741,
		9629,
		6697
	],
	"./87/Spectate/HomeSection.layout": [
		86303,
		9629,
		7114
	],
	"./87/Spectate/SecondaryMenu.layout": [
		88894,
		9629,
		6229
	],
	"./87/Spectate/UsefulLinks.layout": [
		83500,
		9629,
		8915
	],
	"./88/Spectate/Header.mobile.layout": [
		62673,
		9629,
		4315
	],
	"./88/Spectate/Header.pc.layout": [
		13656,
		9629,
		1112
	],
	"./88/Spectate/HistorySection.layout": [
		35775,
		9629,
		5034
	],
	"./88/Spectate/HomeSection.layout": [
		93218,
		9629,
		2456
	],
	"./88/Spectate/SecondaryMenu.layout": [
		93507,
		9629,
		5412
	],
	"./88/Spectate/UsefulLinks.layout": [
		61209,
		9629,
		8902
	],
	"./89/Spectate/Header.mobile.layout": [
		35006,
		9629,
		5168
	],
	"./89/Spectate/Header.pc.layout": [
		77035,
		9629,
		296,
		3467
	],
	"./89/Spectate/HomeSection.layout": [
		78389,
		9629,
		4024
	],
	"./89/Spectate/SILinks.mobile.layout": [
		54922,
		3538
	],
	"./89/Spectate/SILinks.pc.layout": [
		39143,
		4865
	],
	"./89/Spectate/SecondaryMenu.layout": [
		84560,
		9629,
		1066,
		9423
	],
	"./89/Spectate/UsefulLinks.layout": [
		85458,
		9629,
		1961
	],
	"./90/Spectate/Header.mobile.layout": [
		35608,
		9629,
		5486
	],
	"./90/Spectate/Header.pc.layout": [
		86361,
		9629,
		296,
		1453
	],
	"./90/Spectate/HomeSection.layout": [
		69707,
		9629,
		1606
	],
	"./90/Spectate/SILinks.mobile.layout": [
		19508,
		8008
	],
	"./90/Spectate/SILinks.pc.layout": [
		23109,
		4515
	],
	"./90/Spectate/SecondaryMenu.layout": [
		27186,
		9629,
		1066,
		5817
	],
	"./90/Spectate/UsefulLinks.layout": [
		1496,
		9629,
		799
	],
	"./91/Spectate/Header.mobile.layout": [
		3651,
		9629,
		7113
	],
	"./91/Spectate/Header.pc.layout": [
		39246,
		9629,
		296,
		4194
	],
	"./91/Spectate/HomeSection.layout": [
		76184,
		9629,
		5617
	],
	"./91/Spectate/LeftHeader.pc.layout": [
		77855,
		8469
	],
	"./91/Spectate/SILinks.mobile.layout": [
		26517,
		9237
	],
	"./91/Spectate/SILinks.pc.layout": [
		19404,
		1806
	],
	"./91/Spectate/SecondaryMenu.layout": [
		71917,
		9629,
		1066,
		398
	],
	"./91/Spectate/UsefulLinks.layout": [
		66399,
		9629,
		1204
	],
	"./92/Spectate/Header.mobile.layout": [
		20646,
		9629,
		4872
	],
	"./92/Spectate/Header.pc.layout": [
		85491,
		9629,
		9139
	],
	"./92/Spectate/HomeSection.layout": [
		39549,
		9629,
		4960
	],
	"./92/Spectate/LeftHeader.pc.layout": [
		56526,
		38
	],
	"./92/Spectate/SecondaryMenu.layout": [
		29860,
		9629,
		2916
	],
	"./92/Spectate/UsefulLinks.layout": [
		27818,
		9629,
		8017
	],
	"./94/Spectate/Header.mobile.layout": [
		31108,
		9629,
		2426
	],
	"./94/Spectate/Header.pc.layout": [
		94933,
		9629,
		8918
	],
	"./94/Spectate/HomeSection.layout": [
		82927,
		9629,
		2314
	],
	"./94/Spectate/LeftHeader.pc.layout": [
		58788,
		9392
	],
	"./94/Spectate/SecondaryMenu.layout": [
		58521,
		9629,
		9301
	],
	"./94/Spectate/UsefulLinks.layout": [
		37084,
		9629,
		499
	],
	"./95/Spectate/Header.mobile.layout": [
		40175,
		9629,
		2773
	],
	"./95/Spectate/Header.pc.layout": [
		86730,
		9629,
		478
	],
	"./95/Spectate/HomeSection.layout": [
		41068,
		9629,
		4181
	],
	"./95/Spectate/LeftHeader.pc.layout": [
		6139,
		2533
	],
	"./95/Spectate/SecondaryMenu.layout": [
		71636,
		9629,
		9578
	],
	"./95/Spectate/UsefulLinks.layout": [
		31235,
		9629,
		2360
	],
	"./96/Poker/Header.mobile.layout": [
		21092,
		9629,
		908
	],
	"./96/Poker/Header.pc.layout": [
		71189,
		9629,
		9447
	],
	"./96/Poker/HomeSection.layout": [
		92431,
		9629,
		8860
	],
	"./96/Poker/LoyaltySection.layout": [
		69834,
		9629,
		9929
	],
	"./96/Poker/SecondaryMenu.layout": [
		91694,
		9629,
		7419
	],
	"./96/Poker/UsefulLinks.layout": [
		26908,
		9629,
		5869
	],
	"./96/Spectate/Header.mobile.layout": [
		11170,
		9629,
		4212
	],
	"./96/Spectate/Header.pc.layout": [
		77919,
		9629,
		3885,
		111
	],
	"./96/Spectate/HistorySection.layout": [
		29590,
		9629,
		7439
	],
	"./96/Spectate/HomeSection.layout": [
		27617,
		9629,
		5636
	],
	"./96/Spectate/RegulationLogosSection.layout": [
		87218,
		8619
	],
	"./96/Spectate/SecondaryMenu.layout": [
		45780,
		9629,
		8792,
		8979
	],
	"./96/Spectate/UsefulLinks.layout": [
		90670,
		9629,
		965
	],
	"./default/Kambi/Header.mobile.layout": [
		94143,
		9629,
		8867
	],
	"./default/Kambi/Header.pc.layout": [
		33658,
		1216
	],
	"./default/Kambi/HomeSection.layout": [
		30012,
		9629,
		7315
	],
	"./default/Spectate/Header.mobile.layout": [
		55812,
		9629,
		60
	],
	"./default/Spectate/Header.pc.layout": [
		48245,
		6759
	],
	"./default/Spectate/HomeSection.layout": [
		70767,
		9629,
		2364
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 95275;
module.exports = webpackAsyncContext;